import { createSlice } from '@reduxjs/toolkit';
import {
  getToken,
  logout as logoutService,
  redefinirSenha as redefinirSenhaService,
} from './services';

const initialState = {
  token: undefined,
  refresh_token: '',
  expires_in: 0,
  logged: undefined,
  lastRefresh: undefined,
  loginError: false,
  loginLoading: false,
  redefinirSenhaError: null,
  redefinirSenhaSuccess: null,
  id: '',
  name: '',
  photo: '',
  email: '',
  phone: '',
  endereco: null,
  responsavelId: undefined,
  responsavelNome: '',
  responsavelCnpj: '',
  role: '',
  comercialResponsavel: null
};

const actionLoginSuccess = (state, {payload}) => {
  const {access_token, refresh_token, expires_in} = payload;

  state.token = access_token;
  state.refresh_token = refresh_token;
  state.expires_in = expires_in;
  state.logged = true;
  state.loginError = false;
  state.loginLoading = false;
  window.localStorage.setItem('auth', JSON.stringify(payload));

  if (window.location?.href?.search('auth-data') !== -1) {
    window.location = (process.env.PUBLIC_URL || '') + '/#/home';
  }
};

const actionLoginInit = state => {
  state.loginLoading = true;
};

const actionLoginFail = (state, action) => {
  window.localStorage.clear();

  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key];
  });

  state.loginError = true;
  state.logged = false;
};

const actionClearUser = state => {
  window.localStorage.clear();

  Object.keys(initialState).forEach(key => {
    if (key === 'loginLoading' || key === 'loginError' || key === 'logged') {
      return;
    }
    state[key] = initialState[key];
  });

  state.logged = false;
};

const actionRedefinirSenhaSuccess = (state, {payload}) => {
  state.redefinirSenhaError = null;
  state.redefinirSenhaSuccess = payload;
};

const actionRedefinirSenhaFail = (state, {payload}) => {
  state.redefinirSenhaError = payload;
  state.redefinirSenhaSuccess = null;
};

const actionLogout = state => {
  window.localStorage.clear();

  Object.keys(initialState).forEach(key => {
    state[key] = initialState[key];
  });
};

const actionPersistUser = (state, {payload}) => {
  state.id = payload.id;
  state.name = payload.nomeRazaoResponsavel;
  state.endereco = payload.endereco;
  state.usuario = payload.usuario;
  state.responsavelId = payload.comercialResponsavel?.id;
  state.role = payload.role;
  state.responsavelNome = payload.nomeRazaoResponsavel;
  state.responsavelCnpj = payload.cpfCnpjResponsavel;
  state.photo = payload.fotoPerfil;
  state.comercialResponsavel = payload.comercialResponsavel;
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    loginInit: actionLoginInit,
    loginSuccess: actionLoginSuccess,
    loginFail: actionLoginFail,
    clearUser: actionClearUser,
    persistUser: actionPersistUser,
    logoutSuccess: actionLogout,
    redefinirSenhaSuccess: actionRedefinirSenhaSuccess,
    redefinirSenhaFail: actionRedefinirSenhaFail,
  },
});

export const {actions, reducer} = authSlice;
export const {
  loginInit,
  loginSuccess,
  loginFail,
  clearUser,
  persistUser,
  logoutSuccess,
  redefinirSenhaSuccess,
  redefinirSenhaFail,
} = actions;

export const login = ({username, password}) => async dispatch => {
  try {
    dispatch(loginInit());

    const auth = await getToken(username, password);

    dispatch(loginSuccess(auth));
  } catch (err) {
    dispatch(loginFail());
    console.error('Error on Login', err.response);
  }
};

export const redefinirSenha = email => async dispatch => {
  try {
    const message = await redefinirSenhaService(email);

    dispatch(redefinirSenhaSuccess(message));
  } catch (error) {
    dispatch(redefinirSenhaFail(error.message));
    console.error('Erro ao redefinir senha', error);
  }
};

export const logout = () => async (dispatch, getState) => {
  try {
    await logoutService(getState().Auth.token);

    dispatch({
      type: 'RESET_STATE',
    });
    dispatch(logoutSuccess());
  } catch (err) {
    dispatch(logoutSuccess());
    console.error('Error on Logout', err.response);
  }
};
